import * as THREE from "three";

export const getBoundingBox = (object) => {
  // get bounding box of object - this will be used to setup controls and camera
  let boundingBox = new THREE.Box3();
  boundingBox.setFromObject(object);
  return boundingBox;
};

export const getObjectDimensions = (boundingBox) => {
  let size = new THREE.Vector3();
  size = boundingBox.getSize(size);
  return size;
};

export const getCenter = (boundingBox) => {
  let center = new THREE.Vector3();
  center = boundingBox.getCenter(center);
  return [-center.x, -center.y, -center.z];
};

export const getMaxDimension = (size) => {
  // get the max side of the bounding box (fits to width OR height as needed )
  let maxDim = Math.max(size.x, size.y, size.z);
  return maxDim;
};

export const findMinimumZpoint = (positionArray) => {
  //return the minimum element of the array
  return positionArray
    .filter((point, index) => {
      return index % 3 === 2;
    })
    .sort(function (a, b) {
      return a - b;
    })[0];
};

export const fitObjectPosition = (object, minimumZpoint, initialPosition) => {
  var newObjectPosition = initialPosition;
  var center = new THREE.Vector3();
  const boundingBox = new THREE.Box3();
  // get bounding box of object - this will be used to setup controls and camera
  boundingBox.setFromObject(object);
  center = boundingBox.getCenter(center);
  newObjectPosition = {
    x: -center.x,
    y: -center.y,
    z: -minimumZpoint,
  };

  return [newObjectPosition.x, newObjectPosition.y, newObjectPosition.z];
};

export const defaultGrid = { size: 330, divisions: 33 };
export const minimumDimension = 5;
